var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Detalhes do Workflow")]),_c('button',{on:{"click":_vm.irParaUltimaTarefa}},[_vm._v(" Ver Última Tarefa ")]),_c('pre',[_vm._v(_vm._s(_vm.workflow))])])
}
var staticRenderFns = []

export { render, staticRenderFns }